import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PerformAnalysis.css';

const PerformAnalysis = () => {
  const navigate = useNavigate();

  const handleHelpClick = () => {
    navigate('/help');
  };

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleHowToClick = () => {
    navigate('/how-to');
  };

  return (
    <div className="perform-analysis">
      <div className="accuracy-notice" role="note">
        <strong>Calculation Accuracy Notice</strong>
        <p>
          These modules have been rigorously tested and are believed to
          provide highly accurate results. However, users should independently
          verify important calculations. The developer is not liable for
          errors, omissions, or decisions based on the results.
        </p>
      </div>

      <div className="analysis-content">
        <h2 className="perform-analysis-title">
          Perform Event Analysis
        </h2>

        <div className="analysis-container">
          <div className="button-group">
            <a
              href="https://event-package-website-threshold.streamlit.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="threshold-btn"
            >
              Event Threshold
            </a>

            <a
              href="https://event-package-website.streamlit.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="run-btn"
            >
              Run Event Analysis
            </a>

            <a
              href="https://soluteandsolvent.streamlit.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="solute-solvent-btn"
            >
              Solute and Solvents
            </a>

            <a
              href="https://event-package-website-perform.streamlit.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="perform-btn"
            >
              Statistical Analysis
            </a>
            
            <a
              href="https://dilutepro.streamlit.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="dilute-btn"
            >
              DilutePro
            </a>

            <button className="help-btn" onClick={handleHelpClick}>
              Help
            </button>

            <button className="home-btn" onClick={handleHomeClick}>
              Home
            </button>

            <button className="blank-btn-1" onClick={handleHowToClick}>
              Sample Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformAnalysis;